var render = function render(_c,_vm){return _c('li',{staticClass:"page-tab",class:_vm.data.staticClass || ''},[(_vm.props.to !== null)?_c('router-link',{staticClass:"page-tab-label",attrs:{"to":_vm.props.to}},[_vm._t("default")],2):_c('span',{staticClass:"page-tab-label"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }